import { type SurveyModel, type ValueChangedEvent } from 'survey-core';

/**
 * By default, SurveyJs does not track timestamps for when a question was answered.
 */
export const addTimestampToAnswers = (
  survey: SurveyModel,
  { question }: ValueChangedEvent,
) => {
  question.answeredAt = new Date().toISOString();
};
